export var REQUEST_LOG_START_KEY = 'ESHOP_SERVER_API_START';
export var REQUEST_LOG_END_KEY = 'ESHOP_SERVER_API_END';
//# sourceMappingURL=constant.js.map